<template>
  <div class="reports__panel--submit">
    <button class="button is-primary" @click="$emit('submit')">
      {{ text }}
    </button>
  </div>
</template>

<script>
export default {
  name: 'reports-panel-submit',
  props: {
    disabled: {
      type: Boolean,
      default: false
    },
    text: {
      type: String,
      default: 'Vis'
    }
  }
}
</script>

<style lang="scss">
.reports__panel--submit {
  display: flex;
  align-items: flex-end;
  padding-bottom: 4px;

  button {
    height: 28px !important;
  }
}
</style>